import { FC } from "react";
import styles from "./AppLogo.module.scss";

type AppLogo = {
  logo: string;
};

const Logo: FC<AppLogo> = ({ logo }) => {
  return (
    <div className={styles.logo}>
      <img src={logo} alt="app logo" />
      <span className={styles.text}>Docusign Integration</span>
    </div>
  );
};

export default Logo;
